module.exports = __webpack_public_path__ + "img/hoel_veien_til_verdens_ende1.42233bca.jpg";